"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssDocsForSymbol = void 0;
const jest_docblock_1 = require("jest-docblock");
function getCssDocsForSymbol(meta, symbol) {
    let commentNode;
    if (symbol._kind === 'class' || symbol._kind === 'element') {
        commentNode =
            meta.simpleSelectors[symbol.name] && meta.simpleSelectors[symbol.name].node.prev();
    }
    else if (symbol._kind === 'var') {
        commentNode = symbol.node.prev();
    }
    if (commentNode && commentNode.type === 'comment') {
        const { comments, pragmas } = jest_docblock_1.parseWithComments(jest_docblock_1.extract(commentNode.toString()));
        const res = {
            description: comments,
            tags: {},
        };
        for (const [pragmaName, pragmaValue] of Object.entries(pragmas)) {
            res.tags[pragmaName] = Array.isArray(pragmaValue) ? pragmaValue.join(' ') : pragmaValue;
        }
        return res;
    }
    return null;
}
exports.getCssDocsForSymbol = getCssDocsForSymbol;
//# sourceMappingURL=cssdocs.js.map